export default __webpack_public_path__ + "static/media/f&b_4.58a92ca2.svg";